
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import QrCodeReader from "@/components/QrCodeReader.vue";
import SimpleDialog from "@/components/SimpleDialog.vue";
import moment from "moment";
import {Getter} from "vuex-class";
import router from "@/router";
import KeyReturningDate from "@/components/keys/actions/KeyReturningDate.vue";
import KeyBookedModal from "@/components/keys/KeyBookedModal.vue";
import { TranslateResult } from "vue-i18n";

@Component({
    components: {
        KeyReturningDate,
        QrCodeReader,
        SimpleDialog,
        KeyBookedModal,
    },
})export default class KeyWithdraw extends Vue {

    get canWithdrawGroup(): boolean {
        return this.statusKeyGroup === "IN_RELAY";
    }

    get canWithdraw()  {
      return (
        this.currentKey && this.isKeyInRelay(this.currentKey)
        && !this.isKeyInConnectedBox(this.currentKey)
        && !this.isKeyBooked(this.currentUser, this.currentKey)
        && (
          this.isAdmin
          || !this.retrieveOnlyBookedKey
          || (
            this.retrieveOnlyBookedKey
            && this.isKeyBookedForCurrentUser(this.currentUser, this.currentKey)
          )
        )
        && this.canDoInEnvCompany("WITHDRAW_KEY")
        && (
          this.isManager
          || this.displayDropRelayBtn
          || this.listView
        )
      );
    }

    get statusKeyGroup(): string {
        if (!this.currentKeyGroup?.id) {
            return null;
        }
        const firstKey: any = this.subObjects?.[0];
        const status: string = firstKey?.status;
        const boxId: number = firstKey?.currentLocation?.Box?.id;
        const diff = this.subObjects.filter((key) => key.status !== status || key.currentLocation?.Box?.id !== boxId);
        return !diff.length ? status : null;
    }

    get currentRelay(): any {
      return this.currentKey?.currentLocation?.Box?.Building?.Relays?.[0];
    }

    get currentRelayType(): string {
        return this.currentRelay?.type;
    }

    get withdrawIcon(): string {
        return (this.isMobile ? "mobile " : "") + (this.currentRelayType === "AGENCY" || this.statusKeyGroup === "IN_RELAY"
            ? "icon-picto_retrait-agence"
            : "icon-picto_retrait-myloby");
    }

    get subObjectWithSameStatus(): any[] {
        return this.subObjects.filter((ck: any) => {
            let sameLocation: boolean;
            try {
                sameLocation = this.currentKey.KeyLocation[0].Location.Box.id === ck.KeyLocation[0].Location.Box.id;
            } catch (err) {
                sameLocation = false;
            }
            return (this.currentKey.status === ck.status) && (sameLocation || ck.status === "CREATED");
        });
    }

    get isManager(): boolean {
      return !!this.currentKey?.legitimateKeyAccess?.keyManagementId;
    }

    @Prop({default: () => ({})})
    public currentKey: any;

    @Prop({default: () => ({})})
    public currentKeyGroup: any;

    @Prop({default: () => []})
    public subObjects: any[];

    @Prop({default: false})
    public listView: boolean;

    @Prop({default: false})
    public disabled: boolean;

    @Getter private currentUser: any;
    @Getter private isAdmin: boolean;
    @Getter private isMobile: boolean;
    @Getter private canDoInEnvCompany: (right: string) => boolean;
    @Getter private isBookedKeyAvailable: (key: any) => boolean;

    private displayQrCodeReader: boolean = false;
    private displayChooseHour: boolean = false;
    private displayValidationModal: boolean = false;
    private token: string = "";
    private qrCodeReaderError: any = null;
    private loadingQrCodeStreamer: boolean = false;
    private estimatedEndDate: string = null;
    private showBooked: boolean = false;
    private subKeys: any = [];
    private bookingWarning: TranslateResult = "";
    private loading: boolean = false;
    private loadingWithdrawQuery: boolean = false;
    private canGuestChooseReturnHour: boolean = false;
    private retrieveOnlyBookedKey: boolean = false;
    private displayDropRelayBtn: boolean = false;
    @Watch("currentKey", { immediate: true, deep: true })
    public async onCurrentKeyChanged(newValue: any, oldValue: any) {
      if (newValue && (newValue.id !== oldValue?.id)) {
        await this.fetchRelayOptions();
        this.$emit("loaded");
      }
    }

    private currentLocation(key) {
        return key?.KeyLocation?.find((kL) => !kL.endDate)?.Location;
    }

    private isKeyInConnectedBox(key): boolean {
        return !!this.currentLocation(key)?.Box?.ConnectedBox;
    }

    private isKeyInRelay = (key: any) => key?.status === "IN_RELAY";

    private isKeyBooked = (user, key) => key.currentBooking ? key.currentBooking.userId !== user?.id
        && moment().isAfter(moment(key.currentBooking.startDate))
        && moment().isBefore(moment(key.currentBooking.endDate)) : false

    private isKeyBookedForCurrentUser = (user, key) => key.currentBooking ? key.currentBooking.userId === user?.id
        && moment().isAfter(moment(key.currentBooking.startDate))
        && moment().isBefore(moment(key.currentBooking.endDate)) : false

  private async fetchRelayOptions() {
    if (this.currentRelay) {
      this.canGuestChooseReturnHour = await this.$store.dispatch("options/readOptionValueByBuilding", {
        buildingId: this.currentRelay.buildingId || this.currentRelay.Building.id,
        optionTypeLabel: "canGuestChooseReturnHour",
      });
      this.retrieveOnlyBookedKey = await this.$store.dispatch("options/readOptionValueByRelay", {
        relayId: this.currentRelay.id,
        optionTypeLabel: "retrieveOnlyBookedKey",
      });
      this.displayDropRelayBtn = await this.$store.dispatch("options/readOptionValueByRelay", {
        relayId: this.currentRelay.id,
        optionTypeLabel: "displayDropRelayBtn",
      });
    }
  }

  private mounted(): void {
    if (this.currentKey) {
      this.fetchRelayOptions();
    }
  }

    private formatDate(date): string {
        return this.$options.filters.formatDateHour(date);
    }

    private async getSubObjectWithSameStatus() {
        const subKeys = this.subObjects.length ? this.subObjects :
            (await this.$store.dispatch("keys/getSubKeys", {id: this.currentKey.id}))?.subKeys;
        return subKeys.filter((ck: any) => {
                let sameLocation: boolean;
                try {
                    sameLocation = this.currentKey.KeyLocation[0].Location.Box.id === ck.KeyLocation[0].Location.Box.id;
                } catch (err) {
                    sameLocation = false;
                }
                return (this.currentKey.status === ck.status) && (sameLocation || ck.status === "CREATED");
            });
    }

    private makeWarningBooking(booking: any): void {
        const startDate: string = this.formatDate(booking.startDate);
        if (booking?.user) {
            this.bookingWarning = this.$i18n.t("key.warningBookingUser", {
                    startDate,
                    userName: booking.groupName
                        || booking.user.displayName || booking.user.email,
                });
        } else {
            this.bookingWarning = this.$i18n.t("key.warningBooking", {
                    startDate,
            });
        }
    }

    private checkNextTemporalInvitation(): Promise<void> {
        this.loading = true;
        this.bookingWarning = "";

        const promiseBookings: Array<Promise<any>> = [];
        if (this.currentKeyGroup.id) {
            promiseBookings.push(
                    this.$store.dispatch("keyGroups/getKeyAccessByGroupId", {
                        id: this.currentKeyGroup?.id,
                    }),
                );
        } else {
            promiseBookings.push(
                this.$store.dispatch("keys/getKeyAccessById", {
                    id: this.currentKey.id,
                }),
                this.getSubObjectWithSameStatus().then((subKeys: any[]) => {
                    return Promise.all(subKeys.map(async (subKey: any) => {
                        const booking: object = await this.$store.dispatch("keys/getKeyAccessById", {
                            id: subKey.id,
                        }).catch();
                        return booking;
                    }));
                }),
            );
          }

        return Promise.all(promiseBookings).then(([ bookingKey, bookingSubKeys]) => {
            const firstBooking: any | undefined = this.currentKeyGroup.id ? bookingKey :
                [...bookingSubKeys, bookingKey].find((booking: any) =>
                        !!booking?.keyAccess);
            if (firstBooking?.keyAccess) {
                this.makeWarningBooking(firstBooking.keyAccess);
            }
        }).finally( () => {
            this.loading = false;
        });
    }

    private resetQrCodeReader(): void {
        this.qrCodeReaderError = null;
        this.displayQrCodeReader = false;
    }

    private validateTime(value) {
        this.estimatedEndDate = (new Date(value)).toISOString().substr(0, 19);
        this.displayChooseHour = false;
        this.displayQrCodeReader = true;
    }

    private readQRCode(params: {token: string, moveAllSubObjects?: boolean}): Promise<any> {
        const {token, moveAllSubObjects} = params;
        this.token = token;
        this.qrCodeReaderError = null;
        this.loadingQrCodeStreamer = true;
        const status: string = this.currentKey?.status || this.statusKeyGroup;
        return this.$store.dispatch(this.currentKeyGroup?.id ? "keyGroups/withdraw" : "locations/qrCodeVerification", {
            token,
            keyId: this.currentKey?.id,
            keyGroupId: this.currentKeyGroup?.id,
            keyStatus: status,
            estimatedEndDate: this.estimatedEndDate,
            referentId: this.currentUser.id,
            moveAllSubObjects: !!this.currentKeyGroup?.id || moveAllSubObjects,
        }).then((res) => {
            if (res.withdrawn) {
                this.successCallback(res);
            } else {
                this.qrCodeReaderError = this.$i18n.t("alerts.error." + res.errorMessage || "default");
            }
        }).catch((err) => {
            this.qrCodeReaderError = this.$i18n.t(`alerts.error.${err?.response?.data?.error || "qrCodeNotFound"}`);
        }).finally(() => {
            this.loadingQrCodeStreamer = false;
        });
    }

    private beforeDestroy() {
        this.resetQrCodeReader();
    }

    private successCallback(res: any, way?: string): void {
        if (way === "qrCodePin") {
            this.displayValidationModal = true;
        } else if (res.keysNotMoved?.length > 0) {
            this.$store.commit("alerts/displayWarning", {
                msg: `${this.$i18n?.t("alerts.error.cannotMoveObject", {
                    objects: res.keysNotMoved.map((el) => el.name).join(", "),
                })}`,
            });
        } else {
            this.$store.commit("alerts/displaySuccess", {
                icon: this.withdrawIcon,
                msg: this.$i18n?.t("alerts.key.retrieveSuccess", {key: this.currentKey?.name}),
            });
        }
        this.dropKeyDone();
    }

    private dropKeyDone() {
        this.displayValidationModal = false;
        this.displayQrCodeReader = false;
        this.$store.dispatch("context/clearContext");
        this.$emit("reset");
    }

    private async buttonClick(): Promise<void> {
        await this.checkNextTemporalInvitation();
        if (!this.isBookedKeyAvailable(this.currentKey)) {
            this.showBooked = true;
        } else {
            this.canGuestChooseReturnHour
              ? this.displayChooseHour = true
              : this.displayQrCodeReader = true;
        }
    }

    private closeModal() {
        this.showBooked = false;
    }
}
